import {AnnotationTool} from 'substance'
import {DWAnnotationCommand} from '../../../../../lib/commands/DWAnnotationCommand'

import {EmphasisNode} from './nodes/EmphasisNode'
import {EmphasisConverter} from './converters/EmphasisConverter'
import {EmphasisComponent} from './EmphasisComponent'

import './scss/emphasis.scss'

const EmphasisPackage = {
    name: 'emphasis',
    configure: function(configurator, {toolGroup, disableCollapsedCursor}) {

        configurator.addNode(EmphasisNode)
        configurator.addConverter(EmphasisConverter)

        configurator.addComponent('emphasis', EmphasisComponent)

        configurator.addCommand('emphasis', DWAnnotationCommand, {
            nodeType: EmphasisNode.type,
            disableCollapsedCursor
        })
        configurator.addTool('emphasis', AnnotationTool, {
            toolGroup: toolGroup || 'annotations'
        })

        configurator.addIcon('emphasis', {'fontawesome': 'fa-italic'})
        configurator.addLabel('emphasis', {
            en: 'Emphasis',
            de: 'Betonung'
        })

        const combos = {
            standard: {
                'default': 'ctrl+i',
                'mac': 'cmd+i'
            }
        }

        configurator.addKeyboardShortcut(combos, {command: 'emphasis'}, false, configurator.getLabelProvider().getLabel(this.name))
    }
}

export {EmphasisPackage}
